import { SupplierI } from '../../../../pages/TenderViewPage/types';
import { SupplierScoreBreakdownPanel } from './SupplierScoreBreakdownPanel';

export function ScoreHoverPanelContent({
    item,
    supplierListPosition
}: {
    item: SupplierI;
    supplierListPosition?: number;
}) {
    return <SupplierScoreBreakdownPanel item={item} variant="popover" supplierListPosition={supplierListPosition} />;
}
